export default __webpack_public_path__ + "static/media/vege+fish.276c43c3.png";